import initialState from '../store/initial-state'
import {
  BITACORA_GET_DATA,
  BITACORA_GET_DATA_SUCCESS,
  BITACORA_GET_DATA_FAILURE,
} from '../constants/bitacora-types'

export default (state = initialState.bitacora, action) => {
  switch (action.type) {
    case BITACORA_GET_DATA:
      return {
        ...state,
        isFetching: true,
        data: null,
        headers: null,
        error: null
      }

    case BITACORA_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        error: null
      }

    case BITACORA_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        headers: null,
        error: action.payload
      }

    default: return { ...state }
  }
}
